import React from 'react';
import PropTypes from 'prop-types';
import {Card} from 'wobi-web-common/dist/v2/index.js';
import InsuredIdentitySummary from './InsuredIdentitySummary';

const UserIcon = () => (
  <svg aria-hidden='true' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/><circle cx='12' cy='7' r='4'/>
  </svg>
);

const InsuredIssueCard = ({title, identity, primary = false, children}) => (
  <Card variant='raised' padding='lg' className={primary ? 'insured-issue-card insured-issue-card--primary' : 'insured-issue-card'} style={{borderRadius: 16}}>
    <header className='insured-issue-card__header'>
      <div className='insured-issue-card__title'><span><UserIcon/></span><h2>{title}</h2></div>
      <InsuredIdentitySummary {...identity}/>
    </header>
    {children}
  </Card>
);

InsuredIssueCard.propTypes = {
  children: PropTypes.node.isRequired,
  identity: PropTypes.object.isRequired,
  primary: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default InsuredIssueCard;